module.exports = __webpack_public_path__ + "static/media/directions.6116e913.svg";